
<template>
  <td
    v-if="selectable"
    :class="[`has-text-${align || 'left'}`]"
    class="datatable-cell datatable-cell--align-top"
  >
    <!-- eslint-disable vue/no-mutating-props -->
    <!-- selezione riga: la spunta è memorizzata su row.selected (design ereditato
         da naviga-web; anche TableBody muta item.selected). -->
    <CheckBox
      v-model:checked="row.selected"
      :name="`select_row${rownumber}_check`"
      :size="18"
      checkmark-size="little"
      appearance="secondary"
      rounded
    />
    <!-- eslint-enable vue/no-mutating-props -->
  </td>
  <td
    v-else-if="row && name && expandableRowCheck"
    v-show="!hideColumn"
    :class="[
      `has-text-${align || 'left'}`,
      {'cursor-pointer' : !rowActionDisabled && !!action}
    ]"
    :colspan="expandableRowCheck && name === 'description' ? row.descriptionColspan : null"
    class="datatable-cell"
    @click="!rowActionDisabled && action && action(row)"
  >
    <slot
      :row="row"
      :cell="cellValue"
    >
      {{ cellValue }}
    </slot>
  </td>
</template>

<script>


import CheckBox from '@/components/checkbox/CheckBox.vue';

export default {
  name: 'DataTableColumn',
  components: {
    CheckBox,
  },
  props: {
    row: { type: Object, default: () => {} },
    action: { type: Function, default: null },
    name: { type: String, default: '' },
    type: { type: String, default: '' },
    align: { type: String, default: '' },
    width: { type: String, default: '' },
    customFormat: { type: Function, default: null },
    sortable: { type: Boolean, default: false },
    hiddenHeader: { type: Boolean, default: false },
    hideColumn: { type: Boolean, default: false },
    rowActionDisabled: { type: Boolean, default: false },
    footer: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
    rownumber: { type: Number, default: 0 },
  },
  data() {
    return {
      rowSelected: false,
    };
  },

  computed: {
    rawValue() {
      return this.row[this.name];
    },
    cellValue() {
      if (!this.rawValue && this.type !== 'boolean') return ' ';
      else if (this.customFormat) {
        return this.customFormat(this.rawValue);
      } else if (this.type === 'boolean') {
        return !!this.rawValue;
      } else if (this.type === 'date') {
        return this.$filters.date(this.rawValue, 'YYYY-MM-DD');
      } else if (this.type === 'currency') {
        if (Number.isNaN(this.rawValue)) return ' ';
        return this.$filters.currency(this.rawValue);
      } else if (this.type === 'percentage') {
        if (Number.isNaN(this.rawValue)) return ' ';
        return `${this.$filters.currency(this.rawValue)}%`;
      } else if (this.type === 'quantity') {
        return this.$filters.quantity(this.rawValue);
      } else if (this.type === 'currencyLite') {
        if (Number.isNaN(this.rawValue)) return ' ';
        return this.$filters.currencyLite(this.rawValue);
      }
      return this.rawValue;
    },
    expandableRowCheck() {
      return this.row.isBrackets ? this.name !== 'value' : true;
    },
  },
};
</script>

<style lang="scss">

.datatable-cell {
  &--align-top {
    vertical-align: top !important;
  }

  &:first-child {
    padding-left:1rem;
  }

  &:last-child {
    padding-right:1rem;
  }
}

</style>
